//@flow
import { urlsConstants } from './../_constants/urls.constant';
import { defaultService } from './defaultService';

export const IntegracaoSascLoteService = {
  findByFiltro,
};

function findByFiltro(options: Options, filter: any): Promise<Array<>> {
  return defaultService.findByFiltro(
    `${urlsConstants.INTEGRACAO_LOTE}list`,
    options,
    filter
  );
}
